var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('onboarding-step',{staticClass:"onboarding-onfido"},[_c('user-onfido',{staticClass:"onboarding-onfido__container",attrs:{"sdk-token":_vm.sdkToken},on:{"complete":function($event){return _vm.$emit('complete')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }